module.exports = __webpack_public_path__ + "img/lose.d478e82b.png";